module.exports = __webpack_public_path__ + "static/fig3-acd7c8ed02054ae5eadfc6b869142366.svg";